<template>
  <RadioInputList
    :id="$attrs.id || 'AutoManufacturerYearsRadioList'"
    :key="$attrs.key || 'AutoManufacturerYearsRadioList'"
    v-bind="$attrs"
    :title="$attrs.title || 'Selecione o ano de fabricação do veículo'"
    :options="$attrs.options || cptdAutoManufacturerYearsList"
    :searchable="false"
    @input="$emit('input', $event)"
  />
</template>
<script>
import RadioInputList from '@/components/ui/newComponents/RadioInputList.vue'
export default {
  name: 'AutoManufacturerYearsRadioList',
  components: {
    RadioInputList,
  },
  inheritAttrs: false,
  props: {
    modelYear: { type: [Number, String], default: '' },
    minYear: {
      type: [Number, String],
      default: import.meta.env.VITE_AUTO_EQUITY_MIN_AUTO_MODEL_YEAR_LIST,
    },
  },
  emits: ['input'],
  computed: {
    cptdAutoManufacturerYearsList() {
      const defaultOption = {
        id: Number(this.modelYear),
        label: String(this.modelYear),
        value: Number(this.modelYear),
      }

      if (this.modelYear <= Number(this.minYear)) {
        return [defaultOption]
      }

      return [
        defaultOption,
        {
          value: defaultOption.value - 1,
          id: defaultOption.value - 1,
          label: String(defaultOption.value - 1),
        },
      ]
    },
  },
}
</script>
<style lang="scss"></style>
